import React, {useEffect, useState} from "react"
import {ColumnDef} from "@tanstack/react-table"
import {Link} from "react-router-dom"

import {Card, Loading, Pagination, Table} from "@components/index"
import {useFilter} from "@hooks/useFilter"
import {GameInfo, IGame, IGamePlay, IUser,PagingType} from "@backend/types"
import {GameSearch, GameTitle} from "@modules/game/components"
import {UserInfo, UserSearch} from "@modules/user/components"

import {gamePlayApiCalls} from "../../service"
import {GamePlayStatusBadge} from "../../components"
import {GamePlayStatus, gamePlayStatusEnum} from "../../constants"

const filters = {
    status: Object.keys(gamePlayStatusEnum).reduce((acc, key) => {
        acc[key] = gamePlayStatusEnum[key].title
        return acc
    }, {})
}


const columns: ColumnDef<IGamePlay>[] = [
    {
        header: "Last Play Date",
        accessorKey: "updatedAt",
        enableColumnFilter: true,
        meta: {
            7: "Last 7 Days",
            30: "Last 30 Days",
        },
        cell: ({row: {original}}) =>
            <div className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                <Link to={`${original._id}`} className="text-gray-900 underline">
                    {(new Date(original.updatedAt)).toDateTime(true)}
                </Link>
                <div className="mt-1 text-gray-500">Started: {(new Date(original.createdAt)).toDateTime(true)}</div>
            </div>
    },
    {
        header: "Game",
        accessorKey: "gameId",
        enableColumnFilter: true,
        meta: (onSelect) => <GameSearch onSelect={onSelect}/>,
        cell: ({row: {original}}) => <GameTitle info={(original.gameId as IGame).info as GameInfo}/>
    },
    {
        header: "Player",
        accessorKey: "userId",
        enableColumnFilter: true,
        meta: (onSelect) => <UserSearch onSelect={onSelect}/>,
        cell: ({getValue}) => <UserInfo user={getValue() as IUser}/>
    },
    {
        header: "Status",
        accessorKey: "completeStatus",
        meta: filters.status,
        enableSorting: false,
        cell: ({getValue}) => <GamePlayStatusBadge status={getValue() as GamePlayStatus}/>
    },
]


export function GamePlayList() {
    const {filter, onFilterChange} = useFilter<IGamePlay>(gamePlayApiCalls.apiCalls)
    const [gamePlays, setGamePlays] = useState<PagingType<IGamePlay>>(null)

    useEffect(() => {
        if (!gamePlays)
            gamePlayApiCalls.apiCalls
                .listWithPager({})
                .then(setGamePlays)
    }, [])


    if (!gamePlays)
        return <Loading/>

    console.log("filter", filter)

    return <Card
        bodyClassName="p-0"
        title="Game Plays"
        footer={(filter?.results || gamePlays).totalPages > 1 &&
          <Pagination
            page={filter?.query?.page || 0}
            pageCount={(filter?.results || gamePlays).totalPages}
            onPageChange={onFilterChange}
          />}
    >
        <Table
            isLoading={filter?.isLoading}
            columns={columns}
            onFilterChange={onFilterChange}
            emptyState={{
                title: "No Game Plays Recorded Yet",
                description: "Game play statistics will appear here once users start playing games."
            }}
            sort={[{
                id: "createdAt",
                desc: true
            }]}
            data={(filter?.results || gamePlays || {}).docs || []}
        />
    </Card>
}